import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-358f4e7b"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    "width": "820px"
  }
};
const _hoisted_2 = {
  class: "text_label"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text_label_2"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "icons_po iconfont iconyy-tishi"
}), /*#__PURE__*/_createTextVNode(" 单张图片大小不能超过1M，最多上传 10 张；拖动图片调整顺序")], -1));
const _hoisted_4 = {
  key: 0,
  class: "img_boxs"
};
const _hoisted_5 = ["onMouseenter"];
const _hoisted_6 = {
  key: 0,
  class: "cover text_label_2"
};
const _hoisted_7 = {
  key: 0,
  class: "item_bos undraggable"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", {
  class: "text_label"
}, "上传视频"), /*#__PURE__*/_createElementVNode("span", {
  class: "text_label_2"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "icons_po iconfont iconyy-tishi"
}), /*#__PURE__*/_createTextVNode(" 单个视频大小不超过 100M,仅支持mp4格式，最多上传 1 个")])], -1));
const _hoisted_9 = ["onMouseenter"];
const _hoisted_10 = ["src"];
const _hoisted_11 = ["onClick"];
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icons iconfont iconyy-cha1"
}, null, -1));
const _hoisted_13 = [_hoisted_12];
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text_bot"
}, "默认封面", -1));
const _hoisted_15 = {
  key: 0,
  class: "item_bos"
};
const _hoisted_16 = {
  key: 1,
  class: "item_bos",
  style: {
    "margin-left": "10px"
  }
};
const _hoisted_17 = {
  key: 2,
  class: "item_bos"
};
const _hoisted_18 = ["src"];
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text_bot"
}, "备选封面", -1));
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icons iconfont iconyy-cha1"
}, null, -1));
const _hoisted_21 = [_hoisted_20];
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "rig_text"
}, "若未添加备选封面，默认使用视频第一帧作为封面", -1));
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", {
  class: "text_label"
}, "选择分类")], -1));
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", {
  class: "text_label"
}, "选择话题")], -1));
const _hoisted_25 = {
  class: "topic_box"
};
const _hoisted_26 = ["onClick"];
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", {
  class: "text_label"
}, "标题")], -1));
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", {
  class: "text_label"
}, "详情")], -1));
const _hoisted_29 = {
  class: "btn_box"
};
import { reactive, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import { getCaseCategoryListApi, addCaseApi } from "@/service/modules/case";
import separateUpload from "@/components/separate-upload/index.vue";
import toppicDialog from "./topic-dialog.vue";
import emj from "./emj.vue";
import { VueDraggable } from "vue-draggable-plus";
export default /*#__PURE__*/_defineComponent({
  __name: 'imagetext',
  props: {
    item_Data: {
      type: Object,
      default: () => {}
    },
    tabsActive: {
      default: 1
    }
  },
  emits: ["closes", "restda"],
  setup(__props, {
    emit: __emit
  }) {
    const route = useRoute();
    const router = useRouter();
    const form = reactive({
      title: "",
      cate_id: "",
      thumb: "",
      img_list: "",
      video_list: "",
      desc: "",
      topic_ids: "",
      type: 1
    });
    const list = ref([{
      id: 1,
      name: "Item 1"
    }, {
      id: 2,
      name: "Item 2"
    }, {
      id: 3,
      name: "Item 3"
    }]);
    const emit = __emit;
    function closes() {
      emit("closes");
    }
    const props = __props;
    const img_list = ref([]);
    const video_list = ref([
      // "https://img.yestarshop.com/social_case/2024/0328/202403281634047771.mp4",
    ]);
    const topic_list = ref([]);
    const rules = {
      title: [{
        required: true,
        message: "请输入标题",
        trigger: "blur"
      }],
      cate_id: [{
        required: true,
        message: "请选择分类",
        trigger: "blur"
      }],
      thumb: [{
        required: true,
        message: "请选择封面图",
        trigger: "blur"
      }],
      img_list: [{
        required: true,
        message: "请上传图片",
        trigger: "blur"
      }],
      topic_ids: [{
        required: true,
        message: "请选择话题",
        trigger: "blur"
      }],
      desc: [{
        required: true,
        message: "请输入详情",
        trigger: "blur"
      }],
      video_list: [{
        required: true,
        message: "请上传视频",
        trigger: "blur"
      }]
    };
    const formRef = ref();
    const cate_List = ref([]);
    //获取案例分类
    const cate_lists = async () => {
      let reqdata = {
        page: 1,
        pageSize: 99
      };
      const res = await getCaseCategoryListApi(reqdata);
      cate_List.value = res.data.data;
    };
    const selectionEnd = ref(0);
    const text = ref("");
    const newText = ref("");
    const handleBlur = e => {
      selectionEnd.value = e.srcElement.selectionStart;
    };
    const clickInsert = data => {
      // form.desc = form.desc + data;
      let str = JSON.parse(JSON.stringify(form.desc));
      form.desc = str.slice(0, selectionEnd.value) + data + str.slice(selectionEnd.value);
    };
    function imgLoadSuccess(img) {
      img_list.value.push(img);
    }
    function del_imgs() {
      form.thumb = "";
    }
    function imgTypeError() {
      ElMessage.warning("仅支持jpg/jpeg/png格式图片");
    }
    function videoTypeError() {
      ElMessage.warning("仅支持mp4格式视频");
    }
    function video_thymbTypeError() {
      ElMessage.warning("仅支持jpg/jpeg/png格式视频");
    }
    function videoLoadSuccess(video) {
      video_list.value.push(video);
    }
    function video_thumbLoadSuccess(thumb) {
      form.thumb = thumb;
    }
    const DialogVisible = ref(false);
    const addTopic = () => {
      DialogVisible.value = true;
    };
    const closeDialog = () => {
      DialogVisible.value = false;
    };
    function restData(e) {
      topic_list.value = e;
      closeDialog();
    }
    const deleteTopic = index => {
      topic_list.value.splice(index, 1);
    };
    const hoverIndex = ref(-1);
    function handleImgListEnter(index, img) {
      // if (!form.thumb.includes(img)) {
      //   hoverIndex.value = index;
      // }
    }
    const hover_Index = ref(-1);
    function handlevideoListEnter(index, img) {
      if (!form.thumb.includes(img)) {
        hover_Index.value = index;
      }
    }
    function handleImgListLeave() {
      // hoverIndex.value = -1;
    }
    function handlevideoListLeave() {
      hover_Index.value = -1;
    }
    function handleSettingThumb(img, index) {
      form.thumb = img;
      hoverIndex.value = -1;
      hover_Index.value = -1;
    }
    const loading_img = ref(false);
    function del_img(index) {
      loading_img.value = true;
      img_list.value.splice(index, 1);
      loading_img.value = false;
    }
    function del_video(index) {
      loading_img.value = true;
      video_list.value.splice(index, 1);
      loading_img.value = false;
    }
    const subLoading = ref(false);
    function submitForm(actionType) {
      if (!actionType) {
        closes();
        return;
      }
      //先处理 form 内容
      if (props.tabsActive == 1) {
        if (img_list.value.length > 0) {
          form.img_list = JSON.stringify(img_list.value);
        } else {
          form.img_list = "";
        }
        form.type = 1;
        form.thumb = img_list.value[0];
      }
      if (props.tabsActive == 2) {
        if (video_list.value.length > 0) {
          form.video_list = JSON.stringify(video_list.value);
        } else {
          form.video_list = "";
        }
        form.type = 2;
        if (!form?.thumb) {
          form.thumb = video_list.value[0];
        }
      }
      form.topic_ids = topic_list.value.map(item => {
        return item.id;
      }).toString();
      if (form.thumb == "") {
        ElMessage.error(`请设置一个封面`);
        return;
      }
      formRef.value?.validate(valid => {
        if (valid) {
          submit();
        }
      });
    }
    async function submit() {
      subLoading.value = true;
      let res = await addCaseApi(form);
      ElMessage.success("操作成功");
      subLoading.value = false;
      closes();
    }
    const loading_q = ref(false);
    async function init() {
      if (props.item_Data?.id) {
        loading_q.value = true;
        if (props.tabsActive == 1) {
          img_list.value = JSON.parse(props.item_Data.img_list);
        }
        if (props.tabsActive == 2) {
          video_list.value = JSON.parse(props.item_Data.video_list).length > 0 ? JSON.parse(props.item_Data.video_list) : [];
        }
        let topic_ = JSON.parse(JSON.stringify(props.item_Data.topic_list));
        topic_list.value = topic_.map(item => {
          return {
            ...item,
            is_select: true
          };
        });
        form.title = props.item_Data.title;
        form.desc = props.item_Data.desc;
        form.img_list = props.item_Data.img_list;
        form.cate_id = props.item_Data.cate_id;
        form.thumb = props.item_Data.thumb;
        form.video_list = props.item_Data.video_list;
        form.type = props.item_Data.type;
        form.id = props.item_Data.id;
        loading_q.value = false;
      }
    }
    //监听props.item_Data
    watch(() => props.item_Data, () => {
      init();
    });
    //监听 props.tabsActive
    // watch(
    //   () => props.tabsActive,
    //   () => {
    //     form.thumb=''
    //   }
    // );
    const changeDrag = function (val) {
      // drag.value = val
      console.log(val);
    };
    async function new_inits() {
      await cate_lists();
      await init();
    }
    new_inits();
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_popover = _resolveComponent("el-popover");
      const _component_el_form = _resolveComponent("el-form");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives((_openBlock(), _createBlock(_component_el_form, {
        model: form,
        rules: rules,
        ref_key: "formRef",
        ref: formRef,
        "label-width": "auto",
        "label-position": "left"
      }, {
        default: _withCtx(() => [__props.tabsActive == 1 ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 0,
          prop: __props.tabsActive == 1 ? 'img_list' : ''
        }, {
          label: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_2, "上传图片 (" + _toDisplayString(img_list.value.length) + "/10张)", 1), _hoisted_3])]),
          default: _withCtx(() => [img_list.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_unref(VueDraggable), {
            class: "draggable",
            filter: ".undraggable",
            ref: "el",
            modelValue: img_list.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => img_list.value = $event)
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(img_list.value, (item, index) => {
              return _withDirectives((_openBlock(), _createElementBlock("div", {
                class: "item_bos",
                key: index,
                onMouseenter: $event => handleImgListEnter(index, item),
                onMouseleave: handleImgListLeave
              }, [_createElementVNode("div", null, [_createVNode(_component_el_image, {
                style: {
                  "width": "120px",
                  "height": "120px"
                },
                src: item,
                "preview-src-list": img_list.value,
                "initial-index": index
              }, null, 8, ["src", "preview-src-list", "initial-index"]), index === 0 ? (_openBlock(), _createElementBlock("p", _hoisted_6, "封面图")) : _createCommentVNode("", true)])], 40, _hoisted_5)), [[_directive_loading, loading_img.value]]);
            }), 128)), img_list.value.length < 10 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(separateUpload, {
              maxSize: 1,
              accept: ".jpg, .png, .jpeg",
              "file-types": ['image/png', 'image/jpeg'],
              onTypeError: imgTypeError,
              onUploadSuccess: imgLoadSuccess
            })])) : _createCommentVNode("", true)]),
            _: 1
          }, 8, ["modelValue"])])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["prop"])) : _createCommentVNode("", true), __props.tabsActive == 2 ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 1,
          class: "video-style",
          prop: __props.tabsActive == 2 ? 'video_list' : ''
        }, {
          label: _withCtx(() => [_hoisted_8]),
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(video_list.value, (item, index) => {
            return _openBlock(), _createElementBlock("div", {
              class: "item_bos_video",
              key: index,
              onMouseenter: $event => handlevideoListEnter(index, item),
              onMouseleave: handlevideoListLeave
            }, [_createElementVNode("video", {
              class: "videos",
              src: item,
              controls: "",
              width: "100"
            }, null, 8, _hoisted_10), index == hover_Index.value ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "del",
              onClick: $event => del_video(index)
            }, _hoisted_13, 8, _hoisted_11)) : _createCommentVNode("", true), _hoisted_14], 40, _hoisted_9);
          }), 128)), video_list.value.length < 1 ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createVNode(separateUpload, {
            maxSize: 100,
            "file-types": ['video/mp4'],
            accept: ".mp4",
            onTypeError: videoTypeError,
            onUploadSuccess: videoLoadSuccess
          })])) : _createCommentVNode("", true), video_list.value.length == 1 && form.thumb == '' ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createVNode(separateUpload, {
            maxSize: 1,
            accept: ".jpg, .png, .jpeg",
            "file-types": ['image/png', 'image/jpeg'],
            onTypeError: video_thymbTypeError,
            onUploadSuccess: video_thumbLoadSuccess
          })])) : _createCommentVNode("", true), form.thumb ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createElementVNode("img", {
            src: form.thumb,
            alt: ""
          }, null, 8, _hoisted_18), _hoisted_19, _createElementVNode("div", {
            class: "del",
            onClick: _cache[1] || (_cache[1] = $event => del_imgs())
          }, _hoisted_21)])) : _createCommentVNode("", true), _hoisted_22]),
          _: 1
        }, 8, ["prop"])) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
          prop: "cate_id",
          class: _normalizeClass(__props.tabsActive == 2 ? 'magrin-t-40' : '')
        }, {
          label: _withCtx(() => [_hoisted_23]),
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: form.cate_id,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.cate_id = $event),
            placeholder: "请选择",
            style: {
              "width": "100%"
            }
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cate_List.value, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.name,
                value: item.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }, 8, ["class"]), _createVNode(_component_el_form_item, {
          prop: "topic_ids"
        }, {
          label: _withCtx(() => [_hoisted_24]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_25, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topic_list.value, (item, index) => {
            return _openBlock(), _createElementBlock("div", {
              class: "items_topic",
              key: index
            }, [_createElementVNode("span", null, _toDisplayString(item.name), 1), _createElementVNode("i", {
              onClick: $event => deleteTopic(index),
              class: "icons_fonts iconfont iconyy-cha"
            }, null, 8, _hoisted_26)]);
          }), 128)), _createElementVNode("div", {
            class: "items_add",
            onClick: addTopic
          }, "+ 添加话题")])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          prop: "title"
        }, {
          label: _withCtx(() => [_hoisted_27]),
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.title,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.title = $event),
            "show-word-limit": "",
            maxlength: "20",
            placeholder: ""
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          prop: "desc"
        }, {
          label: _withCtx(() => [_hoisted_28]),
          default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_popover, {
            placement: "right",
            width: 400,
            trigger: "click"
          }, {
            reference: _withCtx(() => [_createVNode(_component_el_button, {
              class: "mb-20"
            }, {
              default: _withCtx(() => [_createTextVNode("添加表情")]),
              _: 1
            })]),
            default: _withCtx(() => [_createVNode(emj, {
              onClickInsert: clickInsert
            })]),
            _: 1
          })]), _createVNode(_component_el_input, {
            modelValue: form.desc,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.desc = $event),
            type: "textarea",
            rows: "10",
            placeholder: "",
            onBlur: handleBlur
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          class: "btn_box_s"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_29, [_createVNode(_component_el_button, {
            type: "",
            onClick: _cache[5] || (_cache[5] = $event => submitForm(false))
          }, {
            default: _withCtx(() => [_createTextVNode("取消")]),
            _: 1
          }), _createVNode(_component_el_button, {
            loading: subLoading.value,
            type: "primary",
            onClick: submitForm
          }, {
            default: _withCtx(() => [_createTextVNode("发布")]),
            _: 1
          }, 8, ["loading"])])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])), [[_directive_loading, loading_q.value]]), DialogVisible.value ? (_openBlock(), _createBlock(toppicDialog, {
        key: 0,
        "dialog-visible": DialogVisible.value,
        onRestData: restData,
        onCloseDialog: closeDialog,
        "item-data": topic_list.value
      }, null, 8, ["dialog-visible", "item-data"])) : _createCommentVNode("", true)]);
    };
  }
});